import React from 'react';
import { IconLock } from '@tabler/icons-react';
import './ProBadge.css';

const ProBadge = ({ small = false, inline = false, className = '' }) => (
  <span
    className={[
      'pro-badge',
      small && 'pro-badge--small',
      inline && 'pro-badge--inline',
      className,
    ].filter(Boolean).join(' ')}
  >
    <span className="pro-badge__icon">
      <IconLock size={small ? 9 : 10} stroke={2.5} />
    </span>
    PRO
  </span>
);

export default ProBadge;
